import { render, staticRenderFns } from "./RouteDesigns.vue?vue&type=template&id=37546bf1&scoped=true&"
import script from "./RouteDesigns.vue?vue&type=script&lang=js&"
export * from "./RouteDesigns.vue?vue&type=script&lang=js&"
import style0 from "./RouteDesigns.vue?vue&type=style&index=0&id=37546bf1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37546bf1",
  null
  
)

export default component.exports